<template>
    <div>
      <div class="top">
        <div style="height: 5rem;background-color:#fff;">
          <div class="logologin">
          <div style="display:flex;flex-direction:row;align-items:center;justify-content:center;background-color:#fff;">
            <div class="regioncss">德宏</div>
            <div>
              <div class="bigtit"> 好房子与高品质项目交流会</div>
              <div class="engtit"> PROJECT MARKETING SEMINAR</div>
            </div>
          </div>
          <!-- <div style="display:flex;align-items:center;justify-content:space-between;display:none;"><div class="loginbtn"  @click="goLogin">登录</div><div style="color:#474747;font-style: italic;cursor:pointer;font-weight:bold;font-size:1.25rem;" @click="goRegister">注册</div></div> -->
        </div>
        </div>
        <img src="../assets/cover.png" alt="" style="width:100%" />
        <!-- <div class="webtit">
          <div class="year">2023</div>
          <div style="color:#fff;font-style: italic">
            <div style="fontSize:2.9375rem;">筑发展▪践未来</div>
            <div style="fontSize:2.9375rem;">好房子与高品质项目交流会</div>
          </div>
        </div> -->
        <div class="knowmore" @click="goKnowMore"><div style="color:#fff;font-size:1.5rem;cursor:pointer;">了解更多</div><i class="el-icon-right" style="font-size:2rem;color:#fff;margin-left:4px;"></i></div>
        <ul>
          <li :class="{ activetab : activeName=='首页'}"  @click="handleClick('首页')">首页</li>
          <li :class="{ activetab : activeName=='新房'}"  @click="handleClick('新房')">新房</li>
          <li :class="{ activetab : activeName=='房产新闻'}"  @click="handleClick('房产新闻')">房产新闻</li>
        </ul>
      </div>
      <div style="background: linear-gradient(to bottom,#ECF4FE, #fff);padding-top:3.75rem;">
        <div class="centerview">
        <!-- 新增视频 -->
        <div class="viewbox">
          <VideoPlay
              style="width:100%!important;height:43rem;backgroundColor:#fff;"
              videoUrl="https://www.ynydc.com/video/showVideoById?id=68741"
              videoCover="https://www.ynydc.com/resources/webapp/realEestateFair/img/video-cover.png"
              :autoplay="false"
              :controls="true"
              :loop="false"
              :muted="false"
              preload="auto"
              :showPlay="true"
              zoom="cotain"
            />
        </div>
        <!-- 领导贺词 -->
          <div class="viewbox" v-if="videosList.length!=0">
            <div class="tit">领导贺词</div>
            <div :class="{vbox:true,verticalcss:index%2==1}" v-for="(item,index) in videosList" :key="index" @click="showVideo(item)">
              <div style="position:relative;backgroundColor:rgba(0,0,0,0.4)">
                <img :src="`${imgsrc}/picture/PLAYBACK_VIDEO_PIC/${item.id}/getPicTypeIdAndFileType`" alt="" style="width:26.25rem;height:14.75rem;object-fit: cover;cursor:pointer;">
                <img src="../assets/images/pause.png" alt="" style="width:5rem;height:5rem;object-fit:contain;position:absolute;left:50%;top:32%;transform:translate(-50%);">
              </div>
              <div style="width:43.75rem;padding:0px 0.625rem;">
                <div style="font-size:2.75rem;color: #F3D9A2;opacity:0.2;">{{transChinese(item.ftitle)}}</div>
                <div style="font-size:1.625rem;color: #454545;">{{item.ftitle}}</div>
                <div style="font-size: 1.375rem;color: #454545;margin:0.5rem 0px;">{{item.fbriefIntroduction}}</div>
                <div style="font-size: 1rem;color: #454545;">{{item.fremark}}</div>
              </div>
            </div>
          </div>
          <!-- 好房视频 -->
          <div class="viewbox" v-if="nicehousevideo.length!=0">
            <div class="tit">好房视频</div>
            <el-carousel height="36rem" indicator-position="outside" @change="changePage" :interval="5000" :autoplay="false" arrow="always">
              <el-carousel-item v-for="(it,ic) in video2Total" :key="ic">
                <div class="vbox" v-for="(item,index) in nicehousevideo" :key="index" @click="showVideo(item)" style="box-shadow:none;height:16rem;">
                  <div style="position:relative;backgroundColor:rgba(0,0,0,0.4)">
                    <img :src="`${imgsrc}/picture/PLAYBACK_VIDEO_PIC/${item.id}/getPicTypeIdAndFileType`" alt="" style="width:26.25rem;height:16rem;object-fit: contain;cursor:pointer;">
                    <img src="../assets/images/pause.png" alt="" style="width:5rem;height:5rem;object-fit:contain;position:absolute;left:50%;top:32%;transform:translate(-50%);">
                  </div>
                  <div style="width:43.75rem;padding:0.625rem;">
                    <div style="font-size:2.75rem;color: #F3D9A2;opacity:0.2;">{{transChinese(item.ftitle)}}</div>
                    <div style="font-size: 1.625rem;color: #454545;">{{item.ftitle}}</div>
                    <div style="font-size: 1.375rem;color: #454545;margin:0.625rem 0px;">{{item.fbriefIntroduction}}</div>
                    <div style="font-size: 1rem;color: #454545;overflow:hidden;text-overflow: ellipsis;-webkit-line-clamp: 5;display: -webkit-box;-webkit-box-orient: vertical;">{{item.fremark}}</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- 德宏好房子 -->
          <div class="viewbox" v-if="houseList.length!=0" id="newHouse">
            <div class="tit">{{countyObj.fValue}}好房子</div>
            <div class="housebox" style="justify-content:flex-start;">
              <div class="houseItm" v-for="(item,index) in houseList" :key="index" @click="goHouseDetail(item)">
                <img :src="`${imgsrc}/picture/BUILD_FILE_COVER_IMAGE/${item.id}/getPicTypeIdAndFileType`" style="width:15.625rem;height:10.9375rem;object-fit:cover;cursor:pointer;">
                <div style="font-weight:bold;margin:0.625rem;height:2.875rem;">[{{item.location}}]</div>
                <div style="font-weight:bold;margin:0.625rem">{{item.preName}}</div>
                <div style="display:flex;justify-content:space-between;align-items:center;">
                  <span style="color:#B8B8B8;font-size:0.9375rem;margin-left:0.625rem;">{{item.tempAverageAmount?'均价:'+ Math.ceil(item.tempAverageAmount) +'元/㎡':'均价:待定'}}</span>
                  <span style="color:#FA512E;font-size:15px;margin-right:0.625rem;">{{item.features.status}}</span>
                </div>
              </div>
            </div>
            <div style="display:flex;flex-direction:column;align-items:center;" v-if="houseStatus==''">
                <span style="fontSize:15px;color:#ccc;cursor:pointer;" @click="loadMoreHouseList">点击加载更多...</span>
                <i class="el-icon-arrow-down" style="fontSize:1.625rem;color:#ccc;"></i>
            </div>
          </div>
          </div>
      </div>
      <div style="background: linear-gradient(to bottom,#f4f9ff, #fff);padding-top:3.75rem;">
          <div class="centerview">
             <!-- 精彩片段 -->
          <div class="viewbox" v-if="brilliantList.length!=0">
            <div class="tit">精彩片段</div>
            <div class="housebox" style="align-items:flex-start;">
                <div style="width:35rem;margin-bottom:2.5rem;" v-for="(item,index) in brilliantList" :key="index" @click="showVideo(item)">
                  <div style="position:relative;backgroundColor:rgba(0,0,0,0.4)">
                    <img :src="`${imgsrc}/picture/PLAYBACK_VIDEO_PIC/${item.id}/getPicTypeIdAndFileType`" style="width:100%;height:19.6875rem;object-fit:cover;cursor:pointer;">
                    <img src="../assets/images/pause.png" alt="" style="width:5rem;height:5rem;object-fit:contain;position:absolute;left:50%;top:32%;transform:translate(-50%);">
                  </div>
                  <div style="padding:0.625rem;">
                    <div style="font-size:1.25rem;color:#454545;margin-bottom:0.625rem;text-align:center;">{{item.ftitle}}</div>
                    <div style="font-size:0.875rem;color:#454545;textAlign:center;">{{item.fremark}}</div>
                  </div>
                </div>
                </div>
                <div style="display:flex;flex-direction:column;align-items:center;" v-if="brilliantstatus==''">
                    <span style="fontSize:15px;color:#ccc;cursor:pointer;" @click="loadMoreBrilliantLis">点击加载更多...</span>
                    <i class="el-icon-arrow-down" style="fontSize:1.625rem;color:#ccc;"></i>
                </div>
                <el-divider content-position="center" v-else>没有更多了</el-divider>
            </div>
            <!-- 会议直播间 -->
          <div class="viewbox" v-if="liveList.length!=0">
            <div class="tit">会议直播间</div>
            <div class="housebox" style="justify-content:flex-start;">
                <div class="livebox" v-for="(item,index) in liveList" :key="index" @click="showLive(item)">
                  <img :src="`${imgsrc}/picture/LIVE_BROADCAST_VIDEO/${item.id}/getPicTypeIdAndFileType`" style="width:100%;height:15.625rem;object-fit:cover;cursor:pointer;">
                  <img src="../assets/images/pause.png" alt="" style="width:5rem;height:5rem;object-fit:contain;position:absolute;left:50%;top:32%;transform:translate(-50%);">
                  <div class="livetag">{{item.ftitle}}</div>
                </div>
            </div>
            <div style="display:flex;flex-direction:column;align-items:center;margin-top:2.5rem;" v-if="livestatus==''">
                <span style="fontSize:15px;color:#ccc;cursor:pointer;" @click="loadMoreLiveLis">点击加载更多...</span>
                <i class="el-icon-arrow-down" style="fontSize:1.625rem;color:#ccc;"></i>
            </div>
            <el-divider content-position="center" v-else>没有更多了</el-divider>
          </div>
          <div style="marginTop:3.75rem;">
            <div style="width:37.5rem;margin:0px auto;">
              <div style="display:flex;width:100%;justify-content:space-between;height:3.75rem;lineHeight:3.75rem;">
                <div :class="{companytag:true,companyactive:companyName=='主办单位'}" @click="chooseCompany('主办单位')">主办单位</div>
                <div :class="{companytag:true,companyactive:companyName=='协办单位'}" @click="chooseCompany('协办单位')">协办单位</div>
                <div :class="{companytag:true,companyactive:companyName=='支持单位'}" @click="chooseCompany('支持单位')">支持单位</div>
                <div :class="{companytag:true,companyactive:companyName=='媒体支持'}" @click="chooseCompany('媒体支持')">媒体支持</div>
              </div>
              <transition name="el-zoom-in-top">
                <div style="display:flex;align-items:center;marginTop:1.25rem;flex-wrap:wrap;" v-show="companyName=='主办单位'">
                    <img src="../assets/images/cenfeng.jpg" alt="" style="width:15rem;margin-right:10px;">
                    <img src="../assets/images/fenghuan.png" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/fs.jpg" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/bfsy.png" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/gyl.jpg" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/huili.jpg" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/mhtc.png" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/slfh.jpg" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/smzg.png" alt="" style="width:8.75rem;margin-right:10px;">
                    <img src="../assets/images/snhy.jpg" alt="" style="width:8.75rem;margin-right:10px;">
                </div>
              </transition>
            </div>
          </div>
          </div>
      </div>
          <el-dialog
              :title="videotitle"
              :visible.sync="centerDialogVisible"
              width="54.125rem"
              center>
              <VideoPlay
                  style="width:100%!important;height:25rem;"
                  v-show="true"
                  :videoUrl="videoUrl"
                  :videoCover="videoCover"
                  :autoplay="true"
                  :controls="true"
                  :loop="false"
                  :muted="false"
                  preload="auto"
                  :showPlay="true"
                  zoom="cotain"
                />
          </el-dialog>
          <div style="height:0.375rem;background:#4963D7;"></div>
          <div style="width:75rem;margin:0 auto;display:flex;flex-direction:row;justify-content:center;">
            <div style="padding-bottom:1.25rem;">
              <div style="textAlign:left;padding-top:2rem;color:#5a5a5a;"><span>公安备案号53010202001422 滇ICP备2022001240号</span></div>
            </div>
          </div>
      </div>
</template>

<script>
import {initHome,loadmore} from '@/api/survey'
import {imgsrc} from '@/api/imageprefix'
import { createLogger } from 'vuex'
import VideoPlay from '@/components/videoplayer'
// import { pinyin } from 'pinyin-pro';
let pinyin = require('js-pinyin');
pinyin.setOptions({checkPolyphone: false, charCase: 2});
export default {
  components:{
    VideoPlay
  },
  name: 'HomeView',
  data(){
    return {
      houseStatus:'',
      videotitle:'',
      videoUrl:'https://cdn.uviewui.com/uview/resources/video.mp4',
		  videoCover: '../assets/images/',
      centerDialogVisible:false,
      brilliantstatus:'',
      livestatus:'',
      activeName: '首页',
      companyName:'主办单位',
      imgsrc:'',
      homeparam:{
        cityId:533100,
        // countyId:'',
        pageSize:8,
        pageNum:0
      },
      video2Total:4,
      countyObj:{
        fValue:'德宏'
      },
      houseList:[],//好房子
      videosList:[],//领导贺词
      nicehousevideo:[],//好房视频
      brilliantList:[],//精彩片段
      liveList:[],//会议直播间
      // 领导贺词	9602 好房视频	9603 精彩片段	9604 会议直播间	9508
      moreparam:{
        fVideoTypeId:9603,
        pageSize:2,
        pageNum:0
      },
      brilliantparam:{
        fVideoTypeId:9604,
        pageSize:2,
        pageNum:0
      },
      liveparam:{
        fVideoTypeId:9508,
        pageSize:4,
        pageNum:0
      },
    }
  },
  created(){
    this.initMoreHouseVideoList()
    this.initMoreBrilliantList()
    this.initliveList()
    this.imgsrc=imgsrc
    let id=this.$route.query.id
    if(typeof(id)!=='undefined' && id!='' && id!=null){
      this.homeparam.cityId=id
    }else{
      this.homeparam.cityId=533100
    }
    this.initCountyandHouseList()

  },
  methods:{
    loadMoreHouseList(){
      this.homeparam.pageSize+=8
      this.initCountyandHouseList()
    },
    transChinese(chinese){
      // return pinyin(chinese)
      return pinyin.getFullChars(chinese)
    },
    goKnowMore(){
      let dom=document.querySelector('#newHouse')
      if(dom){
        document.documentElement.scrollTop=dom.offsetTop
      }
    },
    goHouseDetail(item){
      window.location.href=`https://www.ynydc.com/build/${item.id}/fatherPremessDetail`
    },
    showVideo(item){
      if(item.filesList && item.filesList.length>0){
        this.videoUrl=`${this.imgsrc}/video/showVideoById?id=${item.filesList[0].id}`
      }else{
        this.videoUrl=``
      }
      this.videoCover=`${this.imgsrc}/picture/PLAYBACK_VIDEO_PIC/${item.id}/getPicTypeIdAndFileType`
      this.videotitle=item.ftitle
      this.centerDialogVisible=true
    },
    showLive(item){
      window.open(item.faddress,"_blank")
    },
    //去登录
    goLogin(){
      window.open('http://oauth2.ynydc.c24de81c0ec0f4c399f1c30067acad75d.cn-shanghai.alicontainer.com/',"_blank")
    },
    //去注册
    goRegister(){
      window.open('http://oauth2.ynydc.c24de81c0ec0f4c399f1c30067acad75d.cn-shanghai.alicontainer.com/reg/personReg?execution=e1s1',"_blank")
    },
    chooseCompany(name){
      this.companyName=name
    },
    changePage(index){
      this.moreparam.pageNum=index
      this.initMoreHouseVideoList()
    },
    handleClick(item){
      this.activeName=item
      if(item=='新房'){
        window.open('https://www.ynydc.com/build/newhouse',"_blank")
      }else if(item=='房产新闻'){
        window.open('https://www.ynydc.com/news/fczx/list',"_blank")
      }
    },
    //会议直播间列表
    initliveList(){
      loadmore(this.liveparam).then(result=>{
        if(result.code==200 && result.data.video1s.length>0){
          let arr=[]
          arr=[...this.liveList,...result.data.video1s]
          this.liveList=arr
        }else{
          this.livestatus='noremore'
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    loadMoreBrilliantLis(){
      this.brilliantparam.pageNum+=1
      this.initMoreBrilliantList()
    },
    loadMoreLiveLis(){
      this.liveparam.pageNum+=1
      this.initliveList()
    },
    initMoreBrilliantList(){
      loadmore(this.brilliantparam).then(result=>{
        console.log("🚀 ~ file: HomeView.vue:348 ~ loadmore ~ result:", result)

        if(result.code==200 && result.data.video3s.length>0){
          let arr=[]
          arr=[...this.brilliantList,...result.data.video3s]
          this.brilliantList=arr
        }else{
          this.brilliantstatus='noremore'
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    initCountyandHouseList(){
      initHome(this.homeparam).then((result) => {
        console.log("🚀 ~ file: HomeView.vue:361 ~ initHome ~ result:", result)
        if(result.code==200){
          this.countyObj=result.data.city
          this.houseList=result.data.fatherPreMesses
          this.videosList=result.data.videos
          if(this.homeparam.pageSize>result.data.fatherPreMesses.length){
            this.houseStatus='nomore'
          }
        }else{
          this.$message({
            type:'error',
            message:'请求异常'
          })
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    initMoreHouseVideoList(){
      loadmore(this.moreparam).then(result=>{
        if(result.code==200){
          this.nicehousevideo=result.data.video2s
          this.video2Total=Math.ceil(result.data.video2Total/2)
        }else{
          this.$message({
            type:'error',
            message:'请求异常'
          })
        }
      }).catch((err) => {
        console.log(err)
      });
    }
  }
}
</script>
<style lang="scss" scoped>
    .top{
      position: relative;
      margin: 0 auto;
      background-color: #EBF4FE;
    }
    .logologin{
      width: 75rem;
      height: 5rem;
      display: flex;
      margin: 0 auto;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .webtit{
      display: flex;
      flex-direction: row;
      align-items: center;
      position: absolute;
      top:17.625rem;
      left:26.1875rem;
      transform: translateY(-50%);
    }
    .centerview{
      width: 75rem;
      margin: 3.75rem auto;
      margin-top: 0px;
      padding-bottom: 1.25rem;
      margin-bottom: 0px;
    }
    .knowmore{
      padding:0.8125rem 1.375rem;background:#4963D7;display:flex;align-items:center;
      position: absolute;left: 26.25rem;top:42.5625rem;
    }
    ul{
      margin: 0px;
      padding: 0px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      list-style: none;
      width: 75rem;
      background-color:#fff;
      position: absolute;
      left:50%;
      bottom: 0%;
      transform: translate(-50%,50%);
      height: 5rem;
      box-shadow: 0px 1px 12px 0px #ccc;
    }
    li{
      width: 6.5rem;
      height: 5rem;
      line-height: 5rem;
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-style: italic;
      color: #464646;
      cursor: pointer;
      text-align:center;
    }
    .activetab{
      color: #4863D8;
      font-weight: bold;
      border-bottom: 4px solid #4863D8;
    }
    .viewbox{
      margin-bottom: 3.75rem;
    }
    .tit{
      text-align:center;
      padding:1.25rem 0px;
      margin-bottom: 1.25rem;
      font-size: 2.625rem;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #454545;
    }
    .vbox{
      display: flex;
      flex-direction: row;
      align-items:flex-end;
      justify-content: space-between;
      margin-bottom: 4.3125rem;
    }
    .verticalcss{
      flex-direction: row-reverse;
    }
    .housebox{
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      justify-content:space-between;
    }
    .livebox{
      position:relative;width:17.75rem;margin-right:1.25rem;margin-bottom: 2.5rem;
      box-shadow:0px 0px 2px 0px #ccc;
      height: 15.6875rem;
    }
    .livebox:nth-child(4n+4){
      margin-right: 0px;
    }
    .houseItm{
      width: 15.625rem;
      box-shadow: 0px 1px 12px 0px #ccc;
      padding-bottom: 10px;
      margin-bottom: 2.5rem;
      margin-right: 4.125rem;
    }
    .houseItm:nth-child(4n+4){
      margin-right: 0px;
    }
    .companytag{
      color:#3E3E3E;
      font-family: Microsoft YaHei;
      font-size: 1.125rem;
      cursor: pointer;
      font-weight: bold;
    }
    .livetag{
      position:absolute;bottom:0px;left:-1px;width:10.125rem;height:2rem;line-height:2rem;font-size: 0.9375rem;
      background: transparent url('../assets/images/background.png') no-repeat;
      background-size:10.125rem  2rem;
      text-align: center;
      background-position: left bottom;
      
    }
    .companyactive{
      color: #2E61DF;
      border-bottom: 2px solid #2E61DF;
    }
    .year{color:#fff;font-size:6.5rem;font-style:italic;margin-right:8px;}
    .regioncss{font-Size:3rem;font-style: italic;color: #3E3E3E;font-family: FZLanTingHei-B-GBK;margin-right:.625rem;}
    .bigtit{color:#4963D7;font-Size:1.75rem;font-style: italic;font-family: FZLanTingHei-B-GBK;font-weight:bold;}
    .engtit{color:#3E3E3E;font-Size:1rem;font-style: italic;font-family: FZLanTingHei-B-GBK;letter-spacing:2px;font-weight:bold;}
    .loginbtn{font-size:1.25rem;background:#4963D7;color:#fff;font-weight:bold;font-style:italic;padding:0.375rem;transform:skew(168deg);cursor:pointer;padding:6px 1.5rem;margin-right:1.9375rem;}
</style>
